import { Tooltip } from "@mui/material";
import { Add } from "@mui/icons-material";
import React, { useEffect, useState } from "react";

import { withStyles } from "tss-react/mui";
import Button from "../CustomButtons/Button";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import DistanceCostSchemeStyle from "./DistanceCostSchemeStyle";
import DistanceSlot from "./DistanceSlot";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

function DistanceCostScheme(props) {
  const [data, setData] = useState([]);
  const [addNewItem, setAddNewItem] = useState(false);

  useEffect(() => {
    setData(props.data ?? []);
  }, [props.data]);

  const handleDataChange = (arrPlace, action, newData = null) => {
    let newSettings = [...data];

    /**
     * ADD NIEUW TIMESLOT
     */
    if (action === "ADD") {
      newSettings.splice(arrPlace, 0, newData);
      setAddNewItem(false);
    }

    /**
     * UPDATE A TIMESLOT
     */
    if (action === "UPDATE") {
      newSettings[arrPlace] = newData;
    }

    /**
     * DELETE A TIME SLOT
     */
    if (action === "DELETE") {
      newSettings.splice(arrPlace, 1);
    }

    setData(newSettings);

    if (newSettings) {
      props.onChange(JSON.stringify(newSettings));
    } else {
      props.onChange("");
    }
  };

  const toggleEmptySlots = () => {
    setAddNewItem(false);
  };

  const { classes } = props;

  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <h5>
            <TranslationWrapper
              tDefault={"Bezorgkosten"}
              tKey={"vestigingen.form.deliverysettings.headers.bezorgkosten"}
            />
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              placement={"bottom"}
              title={<TranslationWrapper tDefault={"Toevoegen"} tKey={"global.tooltip.toevoegen"} />}
            >
              <Button className={classes.actionButton} color={"success"} onClick={() => setAddNewItem(true)} simple>
                <Add className={classes.icon} />
              </Button>
            </Tooltip>
          </h5>
          <p>
            <TranslationWrapper
              tDefault={"Als de afstand niet gevonden wordt dan wordt het hoogste tarief gebruikt."}
              tKey={"vestigingen.form.deliverysettings.headers.bezorgkostenInfo"}
            />
          </p>
        </GridItem>
      </GridContainer>
      <table className={classes.distanceTable}>
        {data.length !== 0 ? (
          <thead>
            <tr>
              <td>
                <b>van</b>
              </td>
              <td>
                <b>tot</b>
              </td>
              <td>
                <b>kosten</b>
              </td>
              <td style={{ width: "200px" }} />
            </tr>
          </thead>
        ) : null}
        {data.map((item, index) => {
          return (
            <DistanceSlot
              arrPlace={index}
              currency={props.valuta}
              handleDataChange={handleDataChange}
              key={item.id ?? String(Math.random())}
              price={item.price}
              startDistance={item.startDistance}
              stopDistance={item.stopDistance}
              toggleEmptySlots={toggleEmptySlots}
            />
          );
        })}
        {addNewItem ? (
          <DistanceSlot
            arrPlace={data.length + 1}
            currency={props.valuta}
            editing
            handleDataChange={handleDataChange}
            isNewSlot
            price={10}
            startDistance={0}
            stopDistance={10}
            toggleEmptySlots={toggleEmptySlots}
          />
        ) : null}
      </table>
    </div>
  );
}

DistanceCostScheme.defaultProps = {
  valuta: "EUR",
};

export default withStyles(DistanceCostScheme, DistanceCostSchemeStyle);
